
export function handleFormularioSegunDatalayer() {

    if (!window.digitalData) return;

    const interval = setInterval(() => {
    const policyData = digitalData.policyholder;
    const btnNo = document.getElementById("no");

    if (policyData == "AUTONOMOS") {

        if (btnNo) {
            // console.log(policyData)
            const preguntas = document.getElementsByClassName("seguro_container")[0];
            const line = document.getElementsByClassName("hr_style")[1];

            btnNo.click();
            preguntas.style.display = "none";
            line.style.display = "none";

        }

        window.site = "Vida_Autonomos";
        window.c_var_4 = "Vida_Autonomos";
        window.c_var_23 = "Autonomos";
        window.c_var_24 = "Autonomos";
        clearInterval(interval);

    } else if (policyData == "PARTICULARES") {
        // console.log(policyData)
        clearInterval(interval);
    }


    }, 500);

}